import BigNumber from "bignumber.js";
import { floor } from "lodash";

export function convertBigNumberToNormal(bigNumber, decimals = 18) {
  const result = new BigNumber(bigNumber?._hex).dividedBy(
    new BigNumber(Math.pow(10, decimals))
  );
  return result.toFixed();
}

export function convertBigNumberStringToNormal(bigNumber, decimals = 18) {
  const result = new BigNumber(bigNumber).dividedBy(
    new BigNumber(Math.pow(10, decimals))
  );
  return result.toFixed();
}

export function convertNormalToBigNumber(number, decimals = 18, fix = 0) {
  return new BigNumber(number)
    .multipliedBy(new BigNumber(Math.pow(10, decimals)))
    .minus(fix)
    .toFixed(0);
}

export function calculatePercentage(numerator, denominator) {
  return new BigNumber(numerator)
    .dividedBy(new BigNumber(denominator))
    .toFixed();
}

export function calculateMultiplied(number1, number2) {
  return new BigNumber(number1).multipliedBy(new BigNumber(number2)).toFixed(0);
}

export function minusBigNumber(number1, number2) {
  return new BigNumber(number1).minus(new BigNumber(number2)).toFixed(0);
}

export function getDeadLine(delay) {
  return Math.floor(new Date().getTime() / 1000 + 60 * delay);
}

export function truncate(num, decimal) {
  const places = 5;
  return num
    ? Number(num) && Number(num) < 0.00001
      ? "< 0.00001"
      : (
        Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places)
      ).toString()
    : "--";
}

export const formatDollarAmount = (num, digits, usd) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
  const formatterWholeNum = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  let formatDollar 
  // const formatDollar = usd
  //   ? formatter.format(floor(num, digits))
  //   : formatter.format(floor(num, digits)).substring(1);
    
  let floatNumber = floor(num, digits)
  let wholeNumber = parseInt(floatNumber);

  if(wholeNumber === floatNumber){
    formatDollar = usd
    ? formatterWholeNum.format(floatNumber)
    : formatterWholeNum.format(floatNumber).substring(1);
  }else{
    formatDollar = usd
    ? formatter.format(floor(num, digits))
    : formatter.format(floor(num, digits)).substring(1);
  }
  return num ? formatDollar : "--";
};

export function truncateString(num, decimals) {
  const decimal = decimals !== undefined ? decimals : 2;
  const places = decimal > 8 ? 8 : decimal;
  const numb = Number(num).toFixed(places + 1);
  const result =
    places === 0
      ? numb.slice(0, numb.length - 2)
      : numb.slice(0, numb.length - 1);
  return result;
}

export function formatSECONDAmount(balance) {
  return truncate(Number(formatDollarAmount(balance, 5)));
}

export function amountAIsLessThanOrEqualAmountB(a, b) {
  const result = new BigNumber(a)
    .multipliedBy(new BigNumber(Math.pow(10, 18)))
    .isLessThanOrEqualTo(
      new BigNumber(b).multipliedBy(new BigNumber(Math.pow(10, 18)))
    );
  return result;
}
